import ErrorBoundary from './components/ErrorBoundary.js';
import { Workbench } from './workbench/Workbench.js';
import { CommandPalette } from './workbench/CommandPalette.js';
import { AuthProvider } from './auth/AuthProvider.js';
import { AuthGate } from './auth/AuthGate.js';
import { useTauriWatcher } from './hooks/useTauriWatcher.js';

function Shell() {
  useTauriWatcher();
  return (
    <>
      <Workbench />
      <CommandPalette />
    </>
  );
}

export function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <AuthGate>
          <Shell />
        </AuthGate>
      </AuthProvider>
    </ErrorBoundary>
  );
}
